import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "diff-stats tw-m-0",
  ref: "root"
}
const _hoisted_2 = { class: "tw-font-semibold tw-flex tw-items-center pull-right" }
const _hoisted_3 = {
  key: 0,
  class: "tw-ml-0.5 tw-mr-2"
}
const _hoisted_4 = ["data-tooltip-content"]
const _hoisted_5 = ["data-tooltip-content"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "tw-pt-1"
}
const _hoisted_8 = { class: "file tw-flex tw-items-center tw-justify-between" }

import {onMounted, onUnmounted} from 'vue';
import {loadMoreFiles} from '../features/repo-diff.ts';
import {diffTreeStore} from '../modules/stores.ts';


export default /*@__PURE__*/_defineComponent({
  __name: 'DiffFileList',
  setup(__props) {

const store = diffTreeStore();

onMounted(() => {
  document.querySelector('#show-file-list-btn').addEventListener('click', toggleFileList);
});

onUnmounted(() => {
  document.querySelector('#show-file-list-btn').removeEventListener('click', toggleFileList);
});

function toggleFileList() {
  store.fileListIsVisible = !store.fileListIsVisible;
}

function diffTypeToString(pType) {
  const diffTypes = {
    1: 'add',
    2: 'modify',
    3: 'del',
    4: 'rename',
    5: 'copy',
  };
  return diffTypes[pType];
}

function diffStatsWidth(adds, dels) {
  return `${adds / (adds + dels) * 100}%`;
}

function loadMoreData() {
  loadMoreFiles(store.linkLoadMore);
}

return (_ctx: any,_cache: any) => {
  return (_unref(store).fileListIsVisible)
    ? (_openBlock(), _createElementBlock("ol", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).files, (file) => {
          return (_openBlock(), _createElementBlock("li", {
            key: file.NameHash
          }, [
            _createElementVNode("div", _hoisted_2, [
              (file.IsBin)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(store).binaryFileMessage), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(file.IsBin ? '' : file.Addition + file.Deletion) + " ", 1 /* TEXT */),
              (!file.IsBin)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "diff-stats-bar tw-mx-2",
                    "data-tooltip-content": _unref(store).statisticsMessage.replace('%d', (file.Addition + file.Deletion)).replace('%d', file.Addition).replace('%d', file.Deletion)
                  }, [
                    _createElementVNode("div", {
                      class: "diff-stats-add-bar",
                      style: _normalizeStyle({ 'width': diffStatsWidth(file.Addition, file.Deletion) })
                    }, null, 4 /* STYLE */)
                  ], 8 /* PROPS */, _hoisted_4))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" todo finish all file status, now modify, add, delete and rename "),
            _createElementVNode("span", {
              class: _normalizeClass(['status', diffTypeToString(file.Type)]),
              "data-tooltip-content": diffTypeToString(file.Type)
            }, " ", 10 /* CLASS, PROPS */, _hoisted_5),
            _createElementVNode("a", {
              class: "file tw-font-mono",
              href: '#diff-' + file.NameHash
            }, _toDisplayString(file.Name), 9 /* TEXT, PROPS */, _hoisted_6)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_unref(store).isIncomplete)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(store).tooManyFilesMessage) + " ", 1 /* TEXT */),
                _createElementVNode("a", {
                  class: _normalizeClass(['ui', 'basic', 'tiny', 'button', _unref(store).isLoadingNewData ? 'disabled' : '']),
                  onClick: _withModifiers(loadMoreData, ["stop"])
                }, _toDisplayString(_unref(store).showMoreMessage), 3 /* TEXT, CLASS */)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */))
    : _createCommentVNode("v-if", true)
}
}

})